/**
 * Sanitizes postMessage data to prevent XSS injection
 */
export function sanitizePostMessageData(data: unknown): string | null {
  try {
    const stringifiedData = JSON.stringify(data);
    return JSON.parse(stringifiedData);
  } catch {
    return null;
  }
}
